
export default function sketch3(p) {
  let stripes = [];
  const numStripes = 10;

  p.setup = () => {
    p.createCanvas(p.windowWidth, p.windowHeight);
    for (let i = 0; i < numStripes; i++) {
      stripes.push({
        x: p.random(p.width),
        y: p.random(p.height),
        width: p.random(20, 50),
        height: p.height,
        speed: p.random(1, 3),
        color: p.color(p.random(100, 255), p.random(100, 255), p.random(100, 255), 150),
      });
    }
  };

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  p.draw = () => {
    p.background(30, 30, 50, 25); // Semi-transparent background for a trailing effect
    stripes.forEach((stripe) => {
      p.fill(stripe.color);
      p.noStroke();
      p.rect(stripe.x, stripe.y, stripe.width, stripe.height);

      // Update position
      stripe.x += stripe.speed;

      // Wrap around edges
      if (stripe.x > p.width) stripe.x = -stripe.width;
    });
  };
}